import { jsx as o, jsxs as f } from "react/jsx-runtime";
import { useId as p, useTracking as v, getText as g } from "../utils.js";
import { forwardRef as b, useRef as k, useImperativeHandle as x, useEffect as y } from "react";
import { AnimatedArrow as T } from "../animated-arrow.js";
import a from "./action-list.module.css.js";
import h from "clsx";
const I = b(
  function({ className: s, size: c = "sm", variant: l = "regular", ...r }, m) {
    const i = k(null), n = p() || "";
    return x(m, () => i.current), y(() => {
      const t = i.current, e = t == null ? void 0 : t.querySelector("h2, h3, h4, h5, h6"), u = (e == null ? void 0 : e.id) || n;
      return e ? (t == null || t.setAttribute("aria-labelledby", e.id = u), e == null || e.setAttribute("aria-hidden", "true")) : t != null && t.ariaLabel || console.warn(t, "must have aria-label or child <Title>."), () => {
        t == null || t.removeAttribute("aria-labelledby"), e == null || e.removeAttribute("aria-hidden");
      };
    }, [n]), /* @__PURE__ */ o(
      "div",
      {
        className: h(
          a.actionList,
          a[l],
          a[c],
          s
        ),
        role: "list",
        ref: i,
        ...r
      }
    );
  }
), j = b(
  function({
    as: s,
    children: c,
    className: l,
    onClick: r,
    tracking: m = !0,
    wrapperProps: i,
    ...n
  }, t) {
    const e = s || "a", u = h(a.actionListItem, l), L = v(m);
    return /* @__PURE__ */ o("div", { role: "listitem", ...i, children: /* @__PURE__ */ f(e, { ...n, className: u, onClick: (d) => {
      L({
        eventCategory: "actionlist",
        eventAction: "click",
        eventLabel: g(d.currentTarget)
      }), r == null || r(d);
    }, ref: t, children: [
      /* @__PURE__ */ o("div", { children: c }),
      /* @__PURE__ */ o(T, {})
    ] }) });
  }
), O = Object.assign(I, {
  Link: j
});
export {
  O as ActionList,
  I as ActionListComp
};
//# sourceMappingURL=action-list.js.map
